import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { makeSelectCasinoSoundsOn } from 'containers/App/selectors';
import {
  addMusicReference,
  removeMusicReference,
  setSoundsEnabled
} from './musicManager';

class BackgroundMusic extends PureComponent {
  addReference() {
    addMusicReference({
      ref: this,
      priority: this.props.priority,
      options: this.props.options
    });
  }

  removeReference() {
    removeMusicReference(this);
  }

  componentDidMount() {
    if (this.props.enabled) {
      this.addReference();
    }
    setSoundsEnabled(this.props.casinoSoundsOn);
  }

  componentWillUnmount() {
    this.removeReference();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.casinoSoundsOn !== this.props.casinoSoundsOn) {
      setSoundsEnabled(this.props.casinoSoundsOn);
    }
    if (prevProps.enabled !== this.props.enabled) {
      if (this.props.enabled) {
        this.addReference();
      } else {
        this.removeReference();
      }
    }
  }

  render() {
    return null;
  }
}

BackgroundMusic.defaultProps = {
  priority: 1,
  enabled: true
};

BackgroundMusic.propTypes = {
  priority: PropTypes.number,
  options: PropTypes.object,
  enabled: PropTypes.bool
};

const mapStateToProps = createStructuredSelector({
  casinoSoundsOn: makeSelectCasinoSoundsOn()
});

const withConnect = connect(mapStateToProps, null);

export default withConnect(BackgroundMusic);
